import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import React, { useContext, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import { MainContext } from "../context/OpenInvoice";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import Container from "@mui/material/Container";
import Totalsum from "../component/TotalSum";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import moment from "moment";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import "moment/locale/he";
import TabelContent from "../component/TabelContent";
import { useNavigate } from "react-router-dom";
import { groupBy } from "lodash";
import TriggersTooltips from "../component/Info";
import DowloadFiles from "../component/DownloadFiles";
import { useErrValidate } from "../utilitis/AuthorizationPage";
import CustomCard from "../styleComp/CustomCard";
import LoadingButton from "@mui/lab/LoadingButton";
import Snackbar from "@mui/material/Snackbar";
import logger from "../utilitis/logger";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const InvoiceList2 = () => {
  const [state, dispatch] = useContext(MainContext);
  const [alertMessage, setAlertMessage] = useState(0);
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [noDetails, setNoDetails] = useState(false);
  const [name, setName] = useState("");
  const [deitalInvoice, setDeitalInvoice] = useState();
  const heightDisplay = window.innerHeight;
  const boxSize = heightDisplay - 260;
  const navigate = useNavigate();
  const encode = localStorage.getItem("encodeUrl");
  const [branchname, setBranchname] = useState(null);
  const { validationPage } = useErrValidate();
  const branchlist = ["41", "23"];
  const [loading, setLoading] = useState({});
  const [snackbar, setSnackbar] = useState(false);

  const handleCloseSnackbar = () => {
    setSnackbar(false);
  };

  const alertValue = (value) => {
    setAlertMessage(value);
  };
  useEffect(() => {
    validationPage("linkopeninvoice");
    async function fetchData() {
      try {
        const response = await axios.get("openInvoices/openInvoices", {
          headers: {
            Authorization:
              "Basic RjlBMTE3OTZGMjEyMDEwMTQ5OTg5NEJBN0E4MzE1QzQ3MUM1MTQ3NTA6TkVP",
          },
          withCredentials: true,
        });
        let response_data = response.data[0];
        if (response.status == 200) {
          setName(response_data["CUSTDES"]);
          const newArray = response_data["NEO_TFNCITEMS2ONE_SUBFORM"].map(
            (item) => {
              return {
                ...item,
                checked: false,
              };
            }
          );

          dispatch({
            type: "DATA_RESPONSE",
            payload: {
              value: newArray,
            },
          });
        }
      } catch (error) {
        if (error.response.status == 404) {
          dispatch({
            type: "DATA_RESPONSE",
            payload: {
              value: [
                {
                  message: "לא קיים חשבוניות לתשלום",
                  NEO_BRANCHDES: "",
                  NEO_BRANCHNAME: "20",
                },
              ],
            },
          });
        } else if (error.response.status == 403) {
          navigate("/");
        } else if (error.response.status == 400) {
          dispatch({
            type: "DATA_RESPONSE",
            payload: {
              value: [
                {
                  message: "תקלה בשירות",
                  NEO_BRANCHDES: "",
                  NEO_BRANCHNAME: "20",
                },
              ],
            },
          });
        }
      }
    }
    fetchData();
  }, [state.length == 0]);

  const groupedState = groupBy(state, "NEO_BRANCHDES");
  const handleAnimalToggle = (ivnum, branch, date) => {
    if (branchlist.includes(branch)) {
      const index = state.findIndex(
        (obj) => obj.IVNUM == ivnum && obj.FNCDATE == date
      );
      dispatch({
        type: "UPDATED_CHECKED",
        payload: {
          id_key: state[index],
          value: (state[index].checked = !state[index].checked),
        },
      });

      const isChecked = state.some((invoice) => invoice.checked === true);
      if (isChecked) {
        setBranchname(branch);
      } else {
        setBranchname(null);
      }
    } else {
      setNoDetails(true);
      setMessage("לא ניתן לשלם בסניף זה באשראי");
      setTimeout(() => setNoDetails(false), 9000);
    }
  };

  const DetailInvoice = async (ivnum) => {
    setLoading((prevState) => ({ ...prevState, [ivnum]: true }));
    try {
      const response = await axios.get(`openInvoices/detailsInvoice/${ivnum}`, {
        withCredentials: true,
      });
      let response_data = response.data;
      setDeitalInvoice(response_data);
      if (response_data.length > 0) {
        setNoDetails(false);
        setMessage("");
        setOpen(true);
      } else if (response_data.length <= 0) {
        setNoDetails(true);
        setMessage("אין מדיע נוסף לחשבונית זאת");
      }
      setTimeout(() => setNoDetails(false), 6000);
    } catch (error) {
      setNoDetails(true);
      setMessage("אין מדיע נוסף לחשבונית זאת");
      logger.error(error);
    }
    setLoading((prevState) => ({ ...prevState, [ivnum]: false }));
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container maxWidth="100%">
      <Box
        sx={{
          padding: "1rem",
          borderRadius: "16px",
          bgcolor: "#f5f6fa",
          height: "66vh",
          overflow: "auto",
          flexGrow: 1,
          display: { xs: "block", md: "none" },
        }}
      >
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={alertMessage < 0 ? true : noDetails ? true : false}
          onClose={handleCloseSnackbar}
          autoHideDuration={5000}
          key={"topcenter"}
        >
          <Alert severity="warning" variant="filled" sx={{ width: "100%" }}>
            {alertMessage < 0 ? "הסכום לתשלום לא יכול להיות שלילי" : message}
          </Alert>
        </Snackbar>
        <br />
        <Typography variant="subtitle1"> שלום {name}</Typography>
        <Typography variant="h5"> חשבוניות לתשלום</Typography>
        {state.length > 0 ? (
          <List>
            {Object.entries(groupedState).map(([branchName, items]) => (
              <div key={branchName}>
                <Typography sx={{ marginTop: "1rem" }}>{branchName}</Typography>
                {state
                  .filter((item) => item.NEO_BRANCHDES === branchName)
                  .map((data, index) => (
                    <Box
                      key={index}
                      sx={{
                        borderRadius: "16px",
                        bgcolor: "#FFFFFF",
                        marginTop: "0.5rem",
                        boxShadow: 1,
                        background: data.SUM < 0 ? "rgb(237,247,237)" : null,
                      }}
                    >
                      {data.SUM != data.IVBALANCE ? (
                        <ListItem>
                          <ListItemText
                            secondary={
                              "יתרה לתשלום " +
                              (data.IVBALANCE < 0
                                ? `${parseFloat(
                                    Math.abs(data.IVBALANCE)
                                  ).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}- ${data.CODE}`
                                : `${parseFloat(
                                    Math.abs(data.IVBALANCE)
                                  ).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })} ${data.CODE}`)
                            }
                            sx={{ textAlign: "end" }}
                          />
                        </ListItem>
                      ) : null}
                      <ListItem>
                        {data.message ||
                        process.env.REACT_APP_PELECARD_OPTION ==
                          "false" ? null : (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={data.checked}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    handleAnimalToggle(
                                      data.IVNUM,
                                      data.NEO_BRANCHNAME,
                                      data.FNCDATE
                                    );
                                  }
                                }}
                                onChange={() =>
                                  handleAnimalToggle(
                                    data.IVNUM,
                                    data.NEO_BRANCHNAME,
                                    data.FNCDATE
                                  )
                                }
                                sx={{
                                  "& .MuiSvgIcon-root": { fontSize: 25 },
                                }}
                                inputProps={{
                                  alt: "Checkbox",
                                }}
                              />
                            }
                            disabled={
                              branchname !== null &&
                              data.NEO_BRANCHNAME !== branchname
                            }
                          />
                        )}
                        <ListItemText
                          primary={
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <span>
                                {data.IVNUM ? data.IVNUM : data.message}
                              </span>
                              <strong>
                                {data.SUM ? (
                                  <span>
                                    {Math.abs(data.SUM)}
                                    {data.SUM < 0 ? "-" : ""} {data.CODE}
                                  </span>
                                ) : null}
                              </strong>
                            </Box>
                          }
                          secondary={
                            data.FNCDATE ? moment(data.FNCDATE).format("L") : ""
                          }
                        />
                      </ListItem>
                      {!data.message ? (
                        <Stack
                          direction="row"
                          justifyContent="flex-end"
                          sx={{ marginRight: "0.5rem" }}
                        >
                          {data.NEO_BRANCHNAME != branchname &&
                          branchname != null ? (
                            <TriggersTooltips branchname={branchname} />
                          ) : null}

                          <DowloadFiles ivnum={data.IVNUM} name={"חשבונית"} />

                          <LoadingButton
                            variant="outlined"
                            // startIcon ={<InfoIcon />}
                            sx={{ marginBottom: "1rem" }}
                            onClick={() => DetailInvoice(data.IVNUM)}
                            loading={loading[data.IVNUM] || false}
                            alt="moreInformation"
                            disabled={
                              branchname == null
                                ? false
                                : data.NEO_BRANCHNAME != branchname
                            }
                          >
                            מידע נוסף
                          </LoadingButton>
                        </Stack>
                      ) : null}
                    </Box>
                  ))}
              </div>
            ))}
          </List>
        ) : (
          <Box>
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
              marginTop="10rem"
            >
              <CircularProgress />
            </Stack>
            <Typography
              variant="h6"
              sx={{
                textAlign: "center",
                color: "#1976D2",
                fontWeight: "bold",
              }}
            >
              LOADING
            </Typography>
          </Box>
        )}
        {/* <Dialog open={open} onClose={handleClose}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            sx={{ marginTop: "1rem" }}
          >
            <Button
              variant="text"
              onClick={handleClose}
              endIcon={<CloseIcon />}
            />
          </Stack>
          <DialogContent style={{ width: "270px" }}>
            {deitalInvoice ? (
              <TabelContent deitalInvoice={deitalInvoice} />
            ) : null}
          </DialogContent>
        </Dialog> */}
        {process.env.REACT_APP_PELECARD_OPTION == "false" ? null : (
          <Totalsum heightDisplay={heightDisplay} alertValue={alertValue} />
        )}
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          display: { xs: "none", md: "block" },
          height: "80%",
          overflow: "auto",
        }}
      >
        <CustomCard overflowCard={"scroll"}>
          <Container>
            <Typography variant="subtitle1"> שלום {name}</Typography>
            <Typography variant="h5"> חשבוניות לתשלום</Typography>
            {process.env.REACT_APP_PELECARD_OPTION == "false" ? null : (
              <Box sx={{ position: "sticky", top: 0, zIndex: 1, opacity: 1 }}>
                <Totalsum
                  heightDisplay={heightDisplay}
                  alertValue={alertValue}
                />
              </Box>
            )}
            <br />
            <Snackbar
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              open={alertMessage < 0 ? true : noDetails ? true : false}
              onClose={handleCloseSnackbar}
              autoHideDuration={5000}
              key={"topcenter"}
            >
              <Alert severity="warning" variant="filled" sx={{ width: "100%" }}>
                {alertMessage < 0
                  ? "הסכום לתשלום לא יכול להיות שלילי"
                  : message}
              </Alert>
            </Snackbar>

            {state.length > 0 ? (
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell>מספר חשבונית</TableCell>
                      <TableCell>סכום לתשלום</TableCell>
                      <TableCell>סכום יתרה</TableCell>
                      <TableCell>תאריך תשלום</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.entries(groupedState).map(([branchName, items]) => (
                      <React.Fragment key={branchName}>
                        {state
                          .filter((item) => item.NEO_BRANCHDES === branchName)
                          .map((data) => (
                            <TableRow
                              key={data.IVNUM}
                              sx={{
                                background:
                                  data.SUM < 0 ? "rgb(237,247,237)" : null,
                              }}
                            >
                              <TableCell>
                                {data.message ||
                                process.env.REACT_APP_PELECARD_OPTION ==
                                  "false" ? null : (
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={data.checked}
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter") {
                                            handleAnimalToggle(
                                              data.IVNUM,
                                              data.NEO_BRANCHNAME,
                                              data.FNCDATE
                                            );
                                          }
                                        }}
                                        onChange={() =>
                                          handleAnimalToggle(
                                            data.IVNUM,
                                            data.NEO_BRANCHNAME,
                                            data.FNCDATE
                                          )
                                        }
                                        sx={{
                                          "& .MuiSvgIcon-root": {
                                            fontSize: 25,
                                          },
                                        }}
                                        inputProps={{
                                          alt: "Checkbox",
                                        }}
                                      />
                                    }
                                    disabled={
                                      branchname !== null &&
                                      data.NEO_BRANCHNAME !== branchname
                                    }
                                  />
                                )}
                              </TableCell>
                              <TableCell>
                                {data.IVNUM ? data.IVNUM : data.message}
                              </TableCell>
                              <TableCell align="left">
                                {data.SUM
                                  ? `${parseFloat(
                                      Math.abs(data.SUM)
                                    ).toLocaleString("en-US", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })} ${data.SUM < 0 ? "-" : ""} ${data.CODE}`
                                  : null}
                              </TableCell>
                              {data.SUM != data.IVBALANCE ? (
                                <TableCell align="left">
                                  {data.IVBALANCE < 0
                                    ? `${parseFloat(
                                        Math.abs(data.IVBALANCE)
                                      ).toLocaleString("en-US", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}- ${data.CODE}`
                                    : `${parseFloat(
                                        Math.abs(data.IVBALANCE)
                                      ).toLocaleString("en-US", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })} ${data.CODE}`}
                                </TableCell>
                              ) : (
                                <TableCell align="left">
                                  {data.SUM
                                    ? `${parseFloat(
                                        Math.abs(data.SUM)
                                      ).toLocaleString("en-US", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })} ${data.SUM < 0 ? "-" : ""} ${
                                        data.CODE
                                      }`
                                    : null}
                                </TableCell>
                              )}

                              <TableCell>
                                {data.FNCDATE
                                  ? moment(data.FNCDATE).format("L")
                                  : ""}
                              </TableCell>

                              <TableCell>
                                {!data.message ? (
                                  <Stack
                                    direction="row"
                                    justifyContent="flex-end"
                                    sx={{ marginRight: "0.5rem" }}
                                  >
                                    {data.NEO_BRANCHNAME != branchname &&
                                    branchname != null ? (
                                      <TriggersTooltips
                                        branchname={branchname}
                                      />
                                    ) : null}

                                    <DowloadFiles
                                      ivnum={data.IVNUM}
                                      name={"חשבונית"}
                                    />

                                    <LoadingButton
                                      variant="outlined"
                                      // startIcon ={<InfoIcon />}
                                      sx={{ marginBottom: "1rem" }}
                                      onClick={() => DetailInvoice(data.IVNUM)}
                                      loading={loading[data.IVNUM] || false}
                                      alt="moreInformation"
                                      disabled={
                                        branchname == null
                                          ? false
                                          : data.NEO_BRANCHNAME != branchname
                                      }
                                    >
                                      מידע נוסף
                                    </LoadingButton>
                                  </Stack>
                                ) : null}
                              </TableCell>
                            </TableRow>
                          ))}
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Box>
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}
                  marginTop="10rem"
                >
                  <CircularProgress />
                </Stack>
                <Typography
                  variant="h6"
                  sx={{
                    textAlign: "center",
                    color: "#1976D2",
                    fontWeight: "bold",
                  }}
                >
                  LOADING
                </Typography>
              </Box>
            )}
          </Container>
        </CustomCard>
      </Box>
      <Dialog open={open} onClose={handleClose} width="80%" fullWidth>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          sx={{ marginTop: "1rem" }}
        >
          <Button
            variant="text"
            onClick={handleClose}
            endIcon={<CloseIcon />}
          />
        </Stack>
        <DialogContent>
          {deitalInvoice ? (
            <TabelContent deitalInvoice={deitalInvoice} />
          ) : null}
        </DialogContent>
      </Dialog>
    </Container>
  );
};

export default InvoiceList2;
